module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-left-arrow-gray-dark-2787e362ffe6fa58dcfde1ee931964d2.svg";